/*global require: false */
require(['jquery'],
    function ($) {
        'use strict';

        $(document).ready(function () {
            console.log("work")

            window.addClass = function
                (size, other, other2) {


                //document.addEventListener("DOMContentLoaded", function () {
                //    function addClass(size, other, other2) {
                const element = document.body;

                element.classList.remove(other);
                element.classList.remove(other2);
                element.classList.add(size);

                localStorage.setItem("selectedFontSize", size);
            };

            const savedSize = localStorage.getItem("selectedFontSize");


            if (savedSize) {
                document.body.classList.add(savedSize);
            } else {
                document.body.classList.add("normal"); //Default size

            }
            /*window.addClass = addClass;*/
        });


        const textSizeEl = document.querySelector('.text-size');
        if (textSizeEl) {
            textSizeEl.addEventListener('keydown', function (event) {
                if (event.target.matches('.text-size a')) {
                    if (event.key === "Enter") {
                        event.preventDefault();
                        event.target.click();
                    }
                }
            });
        }

    });


 
define("text-size-feature", function(){});

